import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-billing-rates',
  templateUrl: './billing-rates.page.html',
  styleUrls: ['./billing-rates.page.scss'],
})
export class BillingRatesPage implements OnInit {

  rates: any = [];
  teamMembers: any[] = [];
  filterEmployee = 'all';
  readonly rounding_increments = [5, 6, 10, 15, 30, 60];

  is_editing = false;
  add_rate = {
    guid: '',
    code: '',
    rate: 0,
    rounded: false,
    rounded_type: 4,
    rounded_time: 5,
    description: '',
    active: true,
    colour: '#FFFFFF',
    user_guid: '',
  }

  get filteredRates(): any[] {
    const rates: any[] = this.rates || [];
    if (this.filterEmployee === 'all') return rates;
    return rates.filter((r: any) => r.user_guid === this.filterEmployee);
  }


  constructor(private apiService: ApiService, public modalController: ModalController, public globalService: GlobalService) { }

  ngOnInit() {
    this.GetData();
    this.GetTeamMembers();
  }

  async GetTeamMembers() {
    let data: any = await this.apiService.get('team_members');
    if (data.success) {
      this.teamMembers = (data.data || []).filter((m: any) => m.active == 1 && m.deleted != 1);
    }
  }

  async GetData() {
    let data: any = await this.apiService.get('billing/rates');
    this.rates = data.success ? (data.data || []) : [];
  }


  async Cancel() {
    this.modalController.dismiss(null);
  }

  async Create() {
    let data: any = await this.apiService.post(`billing/rates`, this.add_rate);
    this.globalService.presentToastMessage(data.message, data.success);
    await this.GetData();
    this.CancelEdit();
  }

  async Update() {
    let data: any = await this.apiService.put(`billing/rates/${this.add_rate.guid}`,this.add_rate);
    this.globalService.presentToastMessage(data.message, data.success);
    await this.GetData();
    this.CancelEdit();
  }

  async Delete(rate) {
    let data: any = await this.apiService.delete(`billing/rates/${rate.guid}`,null);
    this.globalService.RemoveFromArray(this.rates,rate.guid);


  }
  async CancelEdit() {
    this.is_editing = false;
    this.add_rate = {
      guid: '',
      code: '',
      rate: 0,
      rounded: false,
      rounded_type: 4,
      rounded_time: 5,
      description: '',
      active: true,
      colour: '#FFFFFF',
      user_guid: '',
    };
  }

  async Edit(rate) {
    this.is_editing = true;
    this.add_rate = rate;

  }

  

}
